import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { X } from "lucide-react";

type Props = {
  children: React.ReactNode;
  customServicesAgreementUrl?: string | null | undefined;
  agreementType: AgreementType;
};

function VendorAgreement({
  children,
  agreementType,
  customServicesAgreementUrl,
}: Props) {
  let modalTitle;
  let agreementUrl;

  switch (agreementType) {
    case AgreementType.ClientServicesAgreement:
      modalTitle = "Services Agreement";
      agreementUrl = `${AGREEMENT_FOLDER_URL}/hs_client_services_agreement.pdf`;
      break;
    case AgreementType.PlatformUserAgreement:
      modalTitle = "User Agreement";
      agreementUrl = `${AGREEMENT_FOLDER_URL}/hs_platform_user_agreement.pdf`;
      break;
    case AgreementType.SubcontractorAgreement:
      modalTitle = "Subcontractor Agreement";
      agreementUrl = `${AGREEMENT_FOLDER_URL}/hs_subcontractor_services_agreement.pdf`;
      break;
    default:
      modalTitle = "Services Agreement";
      agreementUrl = `${AGREEMENT_FOLDER_URL}/hs_client_services_agreement.pdf`;
  }

  return (
    <Dialog>
      <div className="flex items-center gap-2">
        {children}

        <div className="flex gap-1 text-secondary-foreground">
          I agree with Hotspring's
          <DialogTrigger className="underline cursor-pointer text-service-paint">
            {modalTitle}
          </DialogTrigger>
        </div>
      </div>

      <DialogContent className="max-w-4xl h-[80vh] p-0 overflow-hidden">
        <div className="flex items-center justify-between px-6 pt-4 border-b">
          <DialogTitle className="text-lg font-medium text-white">
            {modalTitle}
          </DialogTitle>
          <DialogClose className="text-gray-500 hover:text-gray-700">
            <X className="w-5 h-5" />
          </DialogClose>
        </div>

        <div className="w-full h-full">
          <embed
            src={customServicesAgreementUrl || agreementUrl}
            type="application/pdf"
            className="w-full h-[80vh]"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export enum AgreementType {
  "SubcontractorAgreement" = "SubcontractorAgreement",
  "ClientServicesAgreement" = "ClientServicesAgreement",
  "PlatformUserAgreement" = "PlatformUserAgreement",
}

export const AGREEMENT_FOLDER_URL =
  "https://hotspring-admin-uploads.s3-us-west-2.amazonaws.com/admin-public-media/agreements";

export default VendorAgreement;
